module.exports = __webpack_public_path__ + "img/bt4_act.d3a22742.png";